export default "__VITE_ASSET__C2XR3VEl__"